var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            "show-loading": _vm.parsing,
            "action-collapse": "",
            title: _vm.$t("Arquivo de conciliação"),
          },
        },
        [
          _c(
            "FormulateForm",
            { ref: "form" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "8" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "reconciliation-file-parser-file",
                          type: "uploader",
                          "max-files": "1",
                          theme: "list",
                          deletable: true,
                          meta: true,
                          label: _vm.$t("Arquivo"),
                          "help-text": _vm.$t(
                            "Arraste o arquivo de conciliação Getnet ou Pix aqui (ou clique para selecionar o arquivo)"
                          ),
                        },
                        on: {
                          input: _vm.onFileChanged,
                          delete: _vm.onFileRemoved,
                        },
                        model: {
                          value: _vm.file,
                          callback: function ($$v) {
                            _vm.file = $$v
                          },
                          expression: "file",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.result
                    ? _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "reconciliation-file-parser-layout",
                              type: "vue-select",
                              clearable: false,
                              label: _vm.$t("Layout"),
                              placeholder: _vm.$t(
                                "Selecione o layout do arquivo"
                              ),
                              options: _vm.layoutOptions,
                            },
                            on: { input: _vm.onLayoutChanged },
                            model: {
                              value: _vm.layout,
                              callback: function ($$v) {
                                _vm.layout = $$v
                              },
                              expression: "layout",
                            },
                          }),
                          _vm.result.layoutDetected
                            ? _c(
                                "b-badge",
                                { attrs: { variant: "light-success" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("Identificado automaticamente")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.result && !_vm.result.layout
            ? _c(
                "b-alert",
                {
                  staticClass: "mt-1",
                  attrs: { show: "", variant: "warning" },
                },
                [
                  _c("div", { staticClass: "alert-body" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "Não foi possível identificar o layout do arquivo automaticamente. Selecione o layout para fazer a leitura."
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.result && _vm.result.layout
        ? _c(
            "b-card-actions",
            { attrs: { "action-collapse": "", title: _vm.$t("Resumo") } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "reconciliation-file-parser-file-name",
                          value: _vm.result.fileName,
                          type: "label",
                          label: _vm.$t("Arquivo"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "reconciliation-file-parser-layout-name",
                          value: _vm.layoutDescription,
                          type: "label",
                          label: _vm.$t("Layout"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "reconciliation-file-parser-total-lines",
                          value: _vm.result.totalLines,
                          type: "label",
                          label: _vm.$t("Linhas no arquivo"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.result.warnings.length
                ? _c(
                    "b-alert",
                    {
                      staticClass: "mt-1 mb-0",
                      attrs: { show: "", variant: "warning" },
                    },
                    [
                      _c("div", { staticClass: "alert-body" }, [
                        _c(
                          "ul",
                          { staticClass: "mb-0 pl-1" },
                          _vm._l(
                            _vm.result.warnings,
                            function (warning, index) {
                              return _c("li", { key: index }, [
                                _vm._v(" " + _vm._s(warning) + " "),
                              ])
                            }
                          ),
                          0
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.result && _vm.result.layout
        ? _c(
            "b-card",
            [
              _c(
                "b-tabs",
                {
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                _vm._l(_vm.sections, function (section) {
                  return _c(
                    "b-tab",
                    {
                      key: section.registryType,
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _vm._v(" " + _vm._s(section.name) + " "),
                                _c(
                                  "b-badge",
                                  {
                                    staticClass: "ml-50",
                                    attrs: { variant: "light-primary" },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(section.rows.length) + " "
                                    ),
                                  ]
                                ),
                                section.errorCount
                                  ? _c(
                                      "b-badge",
                                      {
                                        staticClass: "ml-25",
                                        attrs: {
                                          variant: "light-danger",
                                          title: _vm.$t(
                                            "Linhas com erro de leitura"
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(section.errorCount) + " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-1" },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "search",
                                  placeholder: _vm.$t("Filtrar linhas..."),
                                },
                                model: {
                                  value: _vm.filterText,
                                  callback: function ($$v) {
                                    _vm.filterText = $$v
                                  },
                                  expression: "filterText",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-md-end",
                              attrs: { md: "6" },
                            },
                            [
                              section.errorCount
                                ? _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { switch: "" },
                                      model: {
                                        value: _vm.onlyErrors,
                                        callback: function ($$v) {
                                          _vm.onlyErrors = $$v
                                        },
                                        expression: "onlyErrors",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("Somente linhas com erro")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              section.mapped
                                ? _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: { switch: "" },
                                      model: {
                                        value: _vm.showRaw,
                                        callback: function ($$v) {
                                          _vm.showRaw = $$v
                                        },
                                        expression: "showRaw",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("Exibir linha original")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !section.mapped
                        ? _c("p", { staticClass: "text-muted" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "Este tipo de registro não tem layout mapeado no sistema. As linhas são exibidas como estão no arquivo."
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _c("b-table", {
                        staticClass: "bordered reconciliation-file-table",
                        attrs: {
                          "show-empty": "",
                          responsive: "",
                          striped: "",
                          small: "",
                          "empty-text": _vm.$t("Nenhuma linha encontrada"),
                          fields: section.fields,
                          items: section.items,
                          filter: _vm.filterText || null,
                          "current-page": _vm.currentPage,
                          "per-page": _vm.perPage,
                          "tbody-tr-class": _vm.rowClass,
                        },
                        on: { filtered: _vm.onFiltered },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(error)",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  item.error
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v(" " + _vm._s(item.error) + " ")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "cell(raw)",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c("span", { staticClass: "raw-line" }, [
                                    _vm._v(_vm._s(item.raw)),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell()",
                              fn: function (ref) {
                                var item = ref.item
                                var field = ref.field
                                var value = ref.value
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        "text-danger font-weight-bold":
                                          item.invalidColumns.includes(
                                            field.columnIndex
                                          ),
                                      },
                                      attrs: {
                                        title: _vm.cellTitle(item, field),
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(value) + " ")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c(
                        "b-row",
                        { staticClass: "pt-1" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex align-items-center",
                              attrs: { cols: "6" },
                            },
                            [
                              _c("e-page-size-selector", {
                                attrs: { "per-page": _vm.perPage },
                                on: { change: _vm.onPageSizeChange },
                              }),
                              _c("span", { staticClass: "ml-1 text-muted" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.filteredCount) +
                                    " " +
                                    _vm._s(_vm.$t("linha(s)")) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("b-pagination", {
                                attrs: {
                                  align: "right",
                                  "total-rows": _vm.filteredCount,
                                  "per-page": _vm.perPage,
                                },
                                model: {
                                  value: _vm.currentPage,
                                  callback: function ($$v) {
                                    _vm.currentPage = $$v
                                  },
                                  expression: "currentPage",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }